<template>
  <router-view />
</template>
<script>
export default {
  name: 'SettingIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/setting/Index.vue